import Bookmark from "./Bookmark";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default function BookmarksSection({ title, image, alt, steps }) {
    return (
        <>
            {/* Desktop */}
            <section className="relative min-h-screen overflow-hidden hidden md:flex flex-col justify-center py-16">
                <img src={image} alt={alt} className="absolute right-0 top-0 w-2/3 h-full object-cover" /> {/** w-full h-full */}
                {/* <div className="bg-black/60 absolute inset-0"/> */}
                <div className="absolute right-0 top-0 w-2/3 h-full bg-gradient-to-r from-black to-black/50" />

                <div className="relative z-10  flex flex-col gap-8 md:w-1/2">
                    <h2 className="text-2xl xl:text-4xl font-bold text-mcare-green panoragraf-light text-balance pl-32" data-aos="fade">
                        {title}
                    </h2>

                    <div className="flex flex-col space-y-5">
                        {steps.map((step, index) => (
                            <Bookmark key={index} flag={step} index={index} backgroundColor="bg-mcare-green/50" extraClass="pl-32" titleSize="text-2xl" side="right"/>
                        ))}
                    </div>
                </div>
            </section>

            {/* Mobile */}
            <section className="relative overflow-hidden flex md:hidden flex-col justify-center px-6 py-16">
                <img src={image} alt={alt} className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex flex-col gap-6">
                    <h2 className="text-2xl font-bold text-mcare-green panoragraf-light text-balance text-center" data-aos="fade">
                        {title}
                    </h2>

                    <Swiper
                        slidesPerView={1}
                        centeredSlides
                        spaceBetween={16}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        pagination={{
                            dynamicBullets: true,
                            clickable: true,
                        }}
                        modules={[Pagination, Autoplay]}
                        className="w-full h-48 sm:h-40"
                    >
                        {steps.map((step, index) => (
                            <SwiperSlide key={index}>
                                <Bookmark flag={step} index={index} backgroundColor="bg-mcare-green/50" extraClass="" titleSize="text-2xl" side="right"/>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        </>
    );
}
